export default "__VITE_ASSET__Cjwgi5P4__"